import { render, staticRenderFns } from "./AppsIntegration.vue?vue&type=template&id=9b28978e"
import script from "./AppsIntegration.vue?vue&type=script&lang=ts"
export * from "./AppsIntegration.vue?vue&type=script&lang=ts"
import style0 from "./AppsIntegration.vue?vue&type=style&index=0&id=9b28978e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_css-loader@7.1.2_webpack@5.101.0__ejs@3.1.10_hand_aw7q7g74wxlheijufaycatnd3a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports